import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login'),
      meta: { requiresAuth: false },
    },
    {
      path: '/wx/callback',
      name: 'wx_callback',
      component: () => import('@/views/WxCallback'),
      meta: { requiresAuth: false },
    },
    {
      path: '/user/wx/callback',
      name: 'user_wx_callback',
      component: () => import('@/views/WxCallback'),
      meta: { requiresAuth: false },
    },
    {
      path: '/wx/bind',
      name: 'wx_bind',
      component: () => import('@/views/WxBind'),
      meta: { requiresAuth: false },
    },
    {
      path: '/aigc/real-human-liveness',
      name: 'lm_real_human_liveness',
      meta: { title: '真人素材认证授权', requiresAuth: false },
      component: () => import('@/views/RealHumanLivenessAuth'),
    },
    {
      path: '/largeModel',
      redirect: '/aigc',
    },
    {
      path: '/large-model',
      redirect: '/aigc',
    },
    {
      path: '/',
      redirect: '/aigc/home',
    },
    {
      path: '/aigc',
      name: 'large_model',
      component: () => import('@/views/Layout'),
      redirect: { name: 'lm_home' },
      children: [
        {
          path: 'home',
          name: 'lm_home',
          component: () => import('@/views/Home'),
        },
        {
          path: 'create',
          name: 'lm_image_create',
          meta: { title: '图片创作', lmHidePageHeader: true, lmDocScroll: true },
          component: () => import('@/views/ImageCreate'),
        },
        {
          path: 'projects',
          name: 'lm_projects',
          meta: { title: '项目管理' },
          component: () => import('@/views/Projects'),
        },
        {
          path: 'projects/:projectId/episodes',
          name: 'lm_project_episodes',
          meta: { title: '分集列表' },
          component: () => import('@/views/Episodes'),
        },
        {
          path: 'projects/:projectId/episodes/:episodeId',
          name: 'lm_episode_detail',
          meta: { title: '分镜列表' },
          component: () => import('@/views/EpisodeDetail'),
        },
        {
          path: 'projects/:projectId/episodes/:episodeId/script',
          name: 'lm_episode_script',
          meta: { title: '剧本创作' },
          component: () => import('@/views/EpisodeScript'),
        },
        {
          path: 'works',
          name: 'lm_works',
          meta: { title: '创作案例' },
          component: () => import('@/views/Works'),
        },
        {
          path: 'guide',
          name: 'lm_guide',
          meta: { title: '制作指引' },
          component: () => import('@/views/Guide'),
        },
        {
          path: 'recharge',
          name: 'lm_recharge',
          meta: { title: '积分充值' },
          component: () => import('@/views/PointsRecharge'),
        },
        {
          path: 'balance-recharge',
          name: 'lm_balance_recharge',
          meta: { title: '余额充值' },
          component: () => import('@/views/Recharge'),
        },
        {
          path: 'amount-detail',
          name: 'lm_amount_detail',
          meta: { title: '账单明细', lmDocScroll: true },
          component: () => import('@/views/AmountDetail'),
        },
        {
          path: 'assets',
          redirect: { name: 'lm_assets_roles' },
        },
        {
          path: 'assets/roles',
          name: 'lm_assets_roles',
          meta: { title: '角色库' },
          component: () => import('@/views/AssetsRolesList'),
        },
        {
          path: 'assets/roles/create',
          name: 'lm_assets_roles_create',
          meta: { title: '角色' },
          component: () => import('@/views/AssetsRoleCreate'),
        },
        {
          path: 'assets/roles/:id',
          name: 'lm_assets_roles_detail',
          meta: { title: '角色' },
          component: () => import('@/views/AssetsRoleCreate'),
        },
        {
          path: 'assets/props',
          name: 'lm_assets_props',
          meta: { title: '道具库' },
          component: () => import('@/views/AssetsPropsList'),
        },
        {
          path: 'assets/props/create',
          name: 'lm_assets_props_create',
          meta: { title: '道具' },
          component: () => import('@/views/AssetsPropCreate'),
        },
        {
          path: 'assets/props/:id',
          name: 'lm_assets_props_detail',
          meta: { title: '道具' },
          component: () => import('@/views/AssetsPropCreate'),
        },
        {
          path: 'assets/scenes',
          name: 'lm_assets_scenes',
          meta: { title: '场景库' },
          component: () => import('@/views/AssetsScenesList'),
        },
        {
          path: 'assets/scenes/create',
          name: 'lm_assets_scenes_create',
          meta: { title: '场景' },
          component: () => import('@/views/AssetsScenesCreate'),
        },
        {
          path: 'assets/scenes/:id',
          name: 'lm_assets_scenes_detail',
          meta: { title: '场景' },
          component: () => import('@/views/AssetsScenesCreate'),
        },
        {
          path: 'assets/generate',
          name: 'lm_assets_generate',
          meta: { title: '生成库' },
          component: () => import('@/views/AssetsGenerateList'),
        },
        {
          path: 'assets/favorites',
          name: 'lm_assets_favorites',
          meta: { title: '我的收藏' },
          component: () => import('@/views/FavoritesList'),
        },
        {
          path: 'tools',
          name: 'lm_tools',
          meta: { title: '工具库' },
          component: () => import('@/views/ToolsLibrary'),
        },
        {
          path: 'tools/super-resolution',
          name: 'lm_tools_super_resolution',
          meta: { title: '超分增强' },
          component: () => import('@/views/ToolsSuperResolution'),
        },
        {
          path: 'tools/subtitle-removal',
          name: 'lm_tools_subtitle_removal',
          meta: { title: '字幕擦除' },
          component: () => import('@/views/ToolsSubtitleRemoval'),
        },
      ],
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js